import React, { useState } from 'react';
import { useRouter } from 'next/router';
import { zaraz } from 'zaraz-ts';

import { BeehiivPublicationIds } from '@blockworks/platform/api/beehiiv';

import PageHeader from '@/components/display/headers/page-header';
import NewsletterSubscribeInput from '@/components/pages/frontpage/components/newsletter-subscribe-input';
import subscribeToNewsletter from '@/utils/functions/subscribe-to-newsletter';
import { ZarazTrackEvent } from '@/utils/tracking/const';

import { newsletters } from '../const/newsletters';

import NewsletterCard from './components/newsletter-card';

const NewsletterPageLayout = () => {
    const router = useRouter();
    const [subscribeTo, setSubscribeTo] = useState<BeehiivPublicationIds[]>([BeehiivPublicationIds.TheBreakdown]);
    const source = router.query?.utm_source ? `${router.query?.utm_source}` : 'newsletter-page';
    const campaign = router.query?.utm_campaign ? `${router.query?.utm_campaign}` : '';
    const medium = router.query?.utm_medium ? `${router.query?.utm_medium}` : 'organic';
    const checked = (subscriptionItem: BeehiivPublicationIds) => {
        const isChecked = subscribeTo.includes(subscriptionItem);
        let updatedSubscribeTo: BeehiivPublicationIds[] = [...subscribeTo];
        if (isChecked) {
            // Element exists in the array, remove it
            updatedSubscribeTo = updatedSubscribeTo.filter(subscription => subscription !== subscriptionItem);
        } else {
            // Element does not exist in the array, add it
            updatedSubscribeTo.push(subscriptionItem);
        }
        setSubscribeTo(updatedSubscribeTo);
    };

    return (
        <div className="flex flex-col w-full">
            <div className="flex flex-col mx-auto mt-20 justify-center items-center max-w-[700px] gap-5 px-10">
                <div className="flex flex-col relative gap-3">
                    <PageHeader title="Newsletters" className="!justify-center" />
                    <p className="text-2xl text-center text-brand">Understand the markets in just 5 minutes</p>
                </div>
                <NewsletterSubscribeInput
                    inputPlaceholder="Enter email address"
                    buttonText="Subscribe"
                    source="newsletter-page"
                    shouldAutoFocus
                    onButtonClick={({ email, captchaToken }) =>
                        subscribeToNewsletter({
                            email,
                            subscribeTo,
                            source,
                            sourcePath: router.asPath,
                            campaign,
                            medium,
                            captchaToken,
                        })
                    }
                    onButtonClickSuccess={() => {
                        zaraz.track(ZarazTrackEvent.FacebookCompleteNewsletterRegistration, {
                            content_name: 'Newsletter General',
                        });
                        zaraz.track(ZarazTrackEvent.XCompleteNewsletterRegistration, {
                            content_name: 'Newsletter General',
                        });
                    }}
                />
                <div className="-mt-3.5">
                    <p className="text-xxs text-gray-400">
                        This site is protected by reCAPTCHA and the Google{' '}
                        <a
                            className="text-gray-500 hover:text-gray-600"
                            href="https://policies.google.com/privacy"
                            target="_blank"
                        >
                            Privacy Policy
                        </a>{' '}
                        and{' '}
                        <a
                            className="text-gray-500 hover:text-gray-600"
                            href="https://policies.google.com/terms"
                            target="_blank"
                        >
                            Terms of Service
                        </a>{' '}
                        apply.
                    </p>
                </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-[40px] py-20 px-16 lg:px-24">
                {newsletters.map(newsletter => (
                    <NewsletterCard
                        key={newsletter.title}
                        title={newsletter.title}
                        description={newsletter.description}
                        href={newsletter.href}
                        imageUrl={newsletter.imageUrl}
                        handleCheckMarkClick={() => {
                            checked(newsletter.key);
                        }}
                        isChecked={subscribeTo.includes(newsletter.key)}
                        frequency={newsletter.frequency}
                    />
                ))}
            </div>
        </div>
    );
};

export default NewsletterPageLayout;
